export default "__VITE_ASSET__CTxVNbSC__"